'use client';

import { c as _c } from "react/compiler-runtime";
import Button from '@/shared/components/Button/Button';

/**
 * Small square icon toggle for the Regions section. Switches between
 * 'sector' (single-bar, active-sector zoom) and 'campaign' (11-segment
 * full-war bar).
 */
export default function RegionsViewToggle(t0) {
  const $ = _c(9);
  const {
    value,
    onChange
  } = t0;
  const isCampaign = value === "campaign";
  const next = isCampaign ? "sector" : "campaign";
  const label = isCampaign ? "Switch to sector view (single-bar)" : "Switch to faction view (11-segment bar)";
  let t1;
  if ($[0] !== next || $[1] !== onChange) {
    t1 = () => onChange(next);
    $[0] = next;
    $[1] = onChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `regions-view-${next}`;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><rect x="2" y="2" width="2" height="10" fill="currentColor" /><rect x="6" y="2" width="2" height="10" fill="currentColor" /><rect x="10" y="2" width="2" height="10" fill="currentColor" /></svg>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isCampaign || $[5] !== label || $[6] !== t1 || $[7] !== t2) {
    t4 = <Button size="icon" variant="primary" active={isCampaign} onClick={t1} aria-label={label} aria-pressed={isCampaign} title={label} data-umami-event={t2}>{t3}</Button>;
    $[4] = isCampaign;
    $[5] = label;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}